export const bgImage = (image: string) => (image ? { backgroundImage: `url("${image}")` } : {});

export const bgLogo = (companyCode: string) =>
  companyCode
    ? {
        backgroundImage: `url("https://images.rappi.com/web/travel/autos/providers/${companyCode.toUpperCase()}.png")`,
      }
    : {};
